// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#V-0EE788C6-83F7-4199-91EA-6B505312AD96 .table-filter-icon {\n  font-size: xx-large;\n}\n", "",{"version":3,"sources":["webpack://src/Warehouse/setMinBenefitPercentage/setMinBenefitPercentage.less"],"names":[],"mappings":"AACI;EACI,mBAAA;AAAR","sourcesContent":["#V-0EE788C6-83F7-4199-91EA-6B505312AD96{\n    & .table-filter-icon{\n        font-size: xx-large;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
